import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=17e38c8e&scoped=true&"
import script from "./FeedbackDialog.vue?vue&type=script&lang=ts&"
export * from "./FeedbackDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackDialog.vue?vue&type=style&index=0&id=17e38c8e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e38c8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
